
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import ApiService from '@/services/settings-service.js';
import moment from 'moment';

export default {
  name: 'Vehicle',
  components: {
    // downloadExcel: () => {
    //   if (process.client) {
    //     return import('vue-json-excel');
    //   }
    // },
    VueJsonToCsv: () => {
      if (process.client) {
        return import('vue-json-to-csv');
      }
    },
    VehicleDetailDialog: () => {
      if (process.client) {
        return import('@/components/dialog/VehicleDetailDialog');
      }
    },
  },
  filters: {
    // 時間格式
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  data: () => ({
    // 搜尋框輸入值
    Search: '',
    // datatable 的欄寬平均
    calculateWidths: true,
    downloadList: [],
    ItemsList: [],
    plateList: [],
    // 新增功能Dialog
    addDialog: false,
    updateValue: {},
    componentKey: 0,
    displayDelete: false,
    // Before delete items
    beforeDelete: false,
    itemsToBeDeleted: {},
    showMsg: false,
    msg: '',
  }),
  computed: {
    Headers() {
      return [
        { text: this.$t('Setting.licensePlate'), value: 'plate' },
        { text: this.$t('Setting.department'), value: 'companyGroup' },
        { text: this.$t('Setting.type'), value: 'vehicleType' },
        { text: this.$t('Setting.brand'), value: 'brand' },
        { text: this.$t('Setting.model'), value: 'model' },
        { text: this.$t('Setting.year'), value: 'year' },
        { text: this.$t('Setting.tbox'), value: 'tBoxProvider' },
        { text: this.$t('Setting.runDistance'), value: 'distance' ,align:' d-none'},
        { text: this.$t('Setting.status'), value: 'isActive' },
        { text: this.$t('Setting.lastUpdated'), value: 'updatedAt' },
        {
          text: this.$t('Setting.crudActions'),
          value: 'crudActions',
          sortable: false,
        },
      ];
    },
  },
  watch: {
    displayDelete() {
      setTimeout(() => (this.displayDelete = false), 3000);
    },
    '$store.state.app.locale'(val) {
      this.$i18n.locale = val;
      this.setDownloadList();
    },
    // Change company
    '$store.state.app.company'(val) {
      this.getVehicles();
    },
  },
  mounted() {
    this.getVehicles();
  },
  methods: {
    getVehicles() {
      this.wrapShowloading(
      ApiService.getVehicles(this.$axios)
        .then((response) => {
          if (response) {
            this.ItemsList = response.items;
            this.setDownloadList();
            this.plateList = this.ItemsList.map((x) => x.plate);
            // console.log(this.plateList);
          }
        })
        .catch((error) => {
          console.log('ERROR: getVeicles ' + JSON.stringify(error.response));
        })
      );
    },
    setDownloadList() {
      if (this.ItemsList.length > 0) {
        this.downloadList = [];
        this.ItemsList.forEach((item, i) => {
          this.downloadList.push({});
          this.downloadList[i][this.$t('Setting.licensePlate')] = item.plate;
          this.downloadList[i][this.$t('Setting.department')] =
            item.companyGroup;
            const vt = `Setting.${item.vehicleType.replace("-","")}`
          this.downloadList[i][this.$t('Setting.type')] = this.$t(vt);
          this.downloadList[i][this.$t('Setting.brand')] = item.brand;
          this.downloadList[i][this.$t('Setting.model')] = item.model;
          this.downloadList[i][this.$t('Setting.year')] = item.year;
          this.downloadList[i][this.$t('Setting.tbox')] = item.tBoxProvider;
          
          // this.downloadList[i][this.$t('Setting.runDistance')] = item.distance;
          this.downloadList[i][this.$t('Setting.status')] = item.isActive
            ? this.$t('Setting.Active')
            : this.$t('Setting.Inactive');
          this.downloadList[i][this.$t('Setting.lastUpdated')] =
            moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss') +
            ' (' +
            item.updatedBy +
            ')';
        });
      }
    },
    updateData(val) {
      this.updateValue = val;
      this.addDialog = true;
    },
    beforeDeleteData(val) {
      console.log(val);
      this.beforeDelete = true;
      this.itemsToBeDeleted = val;
    },
    deleteData(val) {
      this.beforeDelete = false;

      // Delete the records in Vuetify datatable and refresh.
      this.ItemsList = this.ItemsList.filter((item) => item.id !== val.id);
      this.plateList = this.ItemsList.map((x) => x.plate);
      // this.forceRerender(val);
      this.displayDelete = true;

      // Delete the records in API
      ApiService.deleteVehicles(this.$axios, val.id)
        .then((response) => {
          this.forceRerenderOnSubmit(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openFileExplorer() {
      this.$refs.fileInputImport.click();
    },
    uploadFile(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      ApiService.postUploadVehicle(this.$axios, formData).then((response) => {
        if (!response.success) {
          this.msg = response.message;
          this.resColor = 'red';
        } else {
          this.msg = this.$t('UploadSuccess');
          this.resColor = 'green';
        }
        this.showMsg = true;
      });
      this.$refs.fileInputImport.value = '';
    },
    // downloadCSV() {
    //   // eslint-disable-next-line
    //   let csvcontent = JSON.parse(JSON.stringify(this.ItemsList));

    //   // Acquire headers
    //   const csvheaders = this.Headers.map((obj) => obj.value);

    //   // Special add
    //   csvheaders.push('updatedBy', 'updatedAt');

    //   // Format companyList as same as display
    //   csvcontent.forEach((item) => {
    //     Object.entries(item).forEach(([key]) => {
    //       // If none of the key in csvcontent satisfies the headers, remove them.
    //       if (!csvheaders.includes(key)) delete item[key];
    //     });
    //   });

    //   // this.copyList.forEach((item) => {
    //   //   csvcontent.push({
    //   //     'License Plate': item.plate,
    //   //     Brand: item.brand,
    //   //     Model: item.model,
    //   //     '4S/MSS2': item.tBoxProvider,
    //   //     Type: item.vehicleType,
    //   //     Year: item.year,
    //   //     Department: item.companyGroup,
    //   //     'Run Distance': item.distance,
    //   //     Status: item.isActive,
    //   //     'Last Updated':
    //   //       moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss') +
    //   //       ' (' +
    //   //       item.updatedBy +
    //   //       ')',
    //   //   });
    //   // });
    //   return csvcontent;
    // },
    addData() {
      this.addDialog = true;
    },
    clearUpdateValue() {
      this.updateValue = {};
    },
    forceRerender(val) {
      this.componentKey += 1;
      this.msg = val.message;
      this.showMsg = true;
    },
    forceRerenderOnSubmit(val) {
      this.componentKey += 1;
      this.ItemsList = [];
      this.getVehicles();
      this.msg = val.message;
      this.showMsg = true;
    },
  },
};
